function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "chevron_back_28"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Body",
  x: 0,
  y: 0,
  width: 20,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.56066017,12.9393398 L13,4.5 C13.5522847,3.94771525 14.4477153,3.94771525 15,4.5 L15,4.5 C15.5522847,5.05228475 15.5522847,5.94771525 15,6.5 L7.5,14 L15,21.5 C15.5522847,22.0522847 15.5522847,22.9477153 15,23.5 L15,23.5 C14.4477153,24.0522847 13.5522847,24.0522847 13,23.5 L4.56066017,15.0606602 C3.97487373,14.4748737 3.97487373,13.5251263 4.56066017,12.9393398 Z",
  id: "Chevron",
  fill: "currentColor"
})));

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "28px",
    viewBox: "0 0 20 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.148a0e29.svg";
export { ForwardRef as ReactComponent };